import store from "@/store";

// The subscription add-on that grants Airteam Inspections. The same entitlement
// gates the annotation UI and, in afp-backend, the damage detection pipeline.
export const DAMAGE_DETECTION_ADDON = "aiInspectionEnabled";

/**
 * Whether the damage detection mode is offered at all.
 *
 * Add-ons are not fetched on anonymous share links and `addonEnabled` permits
 * everything it could not resolve, so this also requires them to be loaded.
 *
 * Reactive inside a computed: the caller re-evaluates once the add-ons have
 * been fetched.
 */
export const damageDetectionAvailable = () =>
  store.getters.subscriptionAddonsLoaded &&
  store.getters.addonEnabled(DAMAGE_DETECTION_ADDON);

// The damage pipelines only scan projects processed since this day. Older
// projects never got a scan, so the mode has nothing to show on them.
export const DAMAGE_DETECTION_SINCE = "2026-09-28";

/**
 * Whether the detection ever ran for this project. The scan is triggered by
 * the photo upload, so that date decides; the creation date stands in when it
 * is missing, and a project without either is given the benefit of the doubt.
 */
export const damageDetectionSupported = (project) => {
  const processedAt = project?.picturesUploadedAt ?? project?.createdAt;
  if (!processedAt) return true;
  return new Date(processedAt) >= new Date(DAMAGE_DETECTION_SINCE);
};

/**
 * When this project was switched on to the damage detection, as a timestamp in
 * milliseconds, or null while it never was.
 *
 * The backend stamps it from the same clock it writes annotation `dateAdded`
 * with, which is what makes the two comparable when the damages are ordered.
 */
export const detectionActivatedAt = () => {
  const activatedAt =
    store.state.section?.config?.damage_detection_mode_activated_at;
  const time = activatedAt ? new Date(activatedAt).getTime() : NaN;
  return Number.isNaN(time) ? null : time;
};

/** Whether this project has confirmed the beta modal. */
export const damageDetectionActivated = () => detectionActivatedAt() !== null;
